import React, {Component} from "react";
import {Form, Input , Radio,Row,Col,Checkbox,InputNumber,Upload,message,Spin,Icon,Modal } from 'antd';
import NHFormItem from '../../common/NHFormItem';
import NHFetch from "../../../utils/NHFetch";
import NHSelect from "../../common/NHSelect";
import {createUuid} from "../../../utils/NHCore";
import NHMultiSelect from "../../common/NHMultiSelect/index";
const Dragger = Upload.Dragger;
const CheckboxGroup = Checkbox.Group;
const { TextArea } = Input;
const basicUrl = '/lcpz/';
/**
 * 绿色通道编辑表单
 * @author admin
 * @date 2018-03-16 11:28:34
 * Version: 1.0
 */
class EditInitForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            previewImage:'',
            previewVisible: false,
            fileList: [],
            uploading:false,
            defaultChecked:[],
            xyxxData: [], //学院下拉数据
            zyxxData: [], //专业下拉数据
            bjxxData: [], //班级下拉数据
            bjvalue:"",
        }
    }



    componentDidMount(){
          
          let initFormData = this.props.initFormData;
          let flag =this.props.flag;
          if(flag){  //加载班级信息的下拉框
              NHFetch(basicUrl + 'getSelectOptionDataByFilter', 'GET', {tag: 'bj', filter: initFormData.TZHZYID.toString()})
              .then(res => {
                  if (res) {
                      
                      this.setState({bjxxData: res.data ? res.data : []});
                  }
              })
          }
          //加载学院信息
          NHFetch(basicUrl + 'getSelectOptionDataByFilter', 'GET', {tag: 'xy', filter: ''})
              .then(res => {
                  if (res) {
                      this.setState({xyxxData: res.data ? res.data : []});
                  }
           })
          //传班级信息给父组件
          if(this.props.getValue!==undefined && (initFormData.TZHBJID !==null || initFormData.TZHBJID!==undefined)  ){
             this.props.getValue(initFormData.TZHBJID)

          }
     
    
      }

      //部门信息选择回调
      handleXyxxChange = (value) => {
        const {getFieldValue, setFieldsValue} = this.props.form;
        if (value && value.length > 0) {
            NHFetch(basicUrl + 'getSelectOptionDataByFilter', 'GET', {tag: 'zy', filter: value.toString()})
                .then(res => {
                    if (res) {
                        let zyids = getFieldValue('zyid');
                        if (zyids && res.data && zyids.length > 0 ){
                            let newData = res.data.map(item => item.VALUE);
                            newData = new Set(newData);
                            let newZyids = zyids.filter(item => newData.has(item));
                            setFieldsValue({zyid:newZyids});
                            this.handleZyxxChange(newZyids);
                        }
                        this.setState({zyxxData: res.data ? res.data : []});
                        setFieldsValue({zy:[], bj:[]});
                    }
                })

        } else {
            const {setFieldsValue} = this.props.form;
            setFieldsValue({zy:[], bj:[]});
            this.setState({zyxxData:[], bjxxData:[]});
        }

    }

      //专业信息选择回调
      handleZyxxChange = (value) => {
          const {getFieldValue, setFieldsValue} = this.props.form;
          if (value && value.length > 0) {

              NHFetch(basicUrl + 'getSelectOptionDataByFilter', 'GET', {tag: 'bj', filter: value.toString()})
                  .then(res => {
                      if (res) {
                          let bjids = getFieldValue('bjid');
                          if (bjids && res.data && bjids.length > 0 ){
                              let newData = res.data.map(item => item.VALUE);
                              newData = new Set(newData);
                              let newBjids = bjids.filter(item => newData.has(item));
                              setFieldsValue({bjid:newBjids});
                          }
                          this.setState({bjxxData: res.data ? res.data : []});
                          setFieldsValue({bj:[]});
                      }
                  })

          } else {
              setFieldsValue({bjid:[]});
              this.setState({bjxxData:[]});
          }
      }
    //
    handleBJxxChange=(value)=>{

      if(this.props.getValue!==undefined){ //审核的事件
        this.props.getValue(value);
      }else{                             //新增的受控
         this.setState({
          bjvalue:value
         })
      }
         
    }


    render() {
        const {form,initFormData,flag} = this.props;
        const { xyxxData, zyxxData, bjxxData } = this.state;
        let formItemLayout = {
            labelCol: { span: 4 },
            wrapperCol: { span: 20 },
        };
        

        return (
            <div>
                <div style={{display:'none'}}>
                    <NHFormItem id={"pkid"}
                        form={this.props.form}
                        initialValue={initFormData.PKID}>
                        <Input />
                    </NHFormItem>
                    <NHFormItem id={"xsid"} required={true} 
                        form={this.props.form}
                        initialValue={initFormData.XSID}>
                        <Input />
                    </NHFormItem>
                    <NHFormItem id={"nd"} required={true} 
                        form={this.props.form}
                        initialValue={initFormData.ND}>
                        <Input />
                    </NHFormItem>
                </div>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>
                        {initFormData.PKID?'':<span style={{marginRight:'4px',fontFamily:'SimSun',fontSize:'14px',color:'#f5222d'}}>*</span>}
                        姓名(学号)：
                    </Col>
                    <Col span={8}>{initFormData.XM}{initFormData.XH}</Col>
                    <Col span={4} style={{textAlign:'right'}}>性别：</Col>
                    <Col span={8}>{initFormData.XB}</Col>
                </Row>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>学院：</Col>
                    <Col span={8}>{initFormData.BMMC}</Col>
                    <Col span={4} style={{textAlign:'right'}}>专业：</Col>
                    <Col span={8}>{initFormData.ZYMC}</Col>
                </Row>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>班级：</Col>
                    <Col span={8}>{initFormData.BJMC}</Col>
                    <Col span={4} style={{textAlign:'right'}}>年度：</Col>
                    <Col span={8}>{initFormData.ND}</Col>
                </Row>
                <NHFormItem id={"tip"}  form={this.props.form} formItemLayout={formItemLayout}>
                    <Row style={{marginLeft:'220px',fontSize:'14px',lineHeight:'1.5'}}>
                        <span style={{textAlign:'right'}}>------申请专业调整------</span>
                    </Row>
                </NHFormItem>
                
                <NHFormItem id={"xy"} required={true} label={"学院"}
                    form={this.props.form} formItemLayout={formItemLayout} 
                    initialValue={initFormData.YXH}>
                    {flag?
                      <NHSelect mode="default" dataSource={xyxxData} onChange={this.handleXyxxChange} style={{width:500}} disabled={true}/>:
                      <NHSelect mode="default" dataSource={xyxxData} onChange={this.handleXyxxChange} style={{width:500}}/>
                    }
                     
                </NHFormItem>
                <NHFormItem id={"zy"} required={true} label={"专业"}
                            initialValue={initFormData.ZYH}
                            form={this.props.form} formItemLayout={formItemLayout}>
                            {flag?
                              <NHSelect mode="default" dataSource={zyxxData}  onChange={this.handleZyxxChange} style={{width:500}} disabled={true}/>:
                              <NHSelect mode="default" dataSource={zyxxData}  onChange={this.handleZyxxChange} style={{width:500}}/>}
                   
                </NHFormItem>
                <NHFormItem id={"bj"} label={"班级"}
                            initialValue={initFormData.BJH} formItemLayout={formItemLayout}
                            form={this.props.form}>
                     <NHSelect  mode="default" dataSource={bjxxData} onChange={this.handleBJxxChange} style={{width:500}} value={this.state.bjvalue}/>
                </NHFormItem>
                <NHFormItem id={"sqly"} required={false} label={"申请理由"}
                            initialValue={initFormData.SQLY}
                            form={this.props.form} formItemLayout={formItemLayout}>
                             {flag?
                             <TextArea maxLength ={80} style={{width:'600px'}} disabled={true}/>:
                             <TextArea maxLength ={80} placeholder="请填写申请理由" style={{width:'600px'}} />}
                </NHFormItem>
               
          
            </div>
        );
    }
}

const EditForm = Form.create()(EditInitForm);

export default EditForm;


// WEBPACK FOOTER //
// ./components/swbl/zytz/EditForm.js